namespace GeniuzPOS.Product {
    export interface ReportExportV1Row {
        Id?: string;
        SkuCode?: string;
        Category?: string;
        Subcategory1?: string;
        Subcategory2?: string;
        BrandId?: string;
        StyleId?: string;
        ColorId?: string;
        SizeId?: string;
        TasteId?: string;
        MatTypeId?: string;
        SkuDesc?: string;
        PluDesc?: string;
        SupplId?: string;
        SupplItemCode?: string;
        StkUnit?: string;
        PurUnit?: string;
        PurUnitRatio?: number;
        StockFg?: number;
        VatType?: string;
        VatCode?: string;
        MinStockQty?: number;
        MaxStockQty?: number;
        PurLeadTime?: number;
        ConsignFg?: number;
        ConsignGp?: number;
        NonAllowtoDiscountFg?: number;
        CusProductTypeNbp?: string;
        CusProductSalesBeforeFlag?: string;
        CusProductSalesBeforeReferFlag?: string;
        CusProductSalesBeforeRefer?: string;
        SellUnitPrice1?: number;
        SellUnitPrice2?: number;
        SellUnitPrice3?: number;
        SellUnitPrice4?: number;
        SellUnitPrice5?: number;
        SellUnitPrice6?: number;
        PurUnitPrice?: number;
        DeliverCost?: number;
        SetItemFg?: number;
        ProductCpDesc1?: string;
        ProductCpDesc2?: string;
        ProductCpComponent?: string;
        ProductCpHowToUse?: string;
        ProductCpWarning?: string;
        CreateDate?: string;
        CreateBy?: string;
    }

    export namespace ReportExportV1Row {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'Product.ReportExportV1';
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:สินค้า:View';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:สินค้า:View';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:สินค้า:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:สินค้า:View';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            Category = "Category",
            Subcategory1 = "Subcategory1",
            Subcategory2 = "Subcategory2",
            BrandId = "BrandId",
            StyleId = "StyleId",
            ColorId = "ColorId",
            SizeId = "SizeId",
            TasteId = "TasteId",
            MatTypeId = "MatTypeId",
            SkuDesc = "SkuDesc",
            PluDesc = "PluDesc",
            SupplId = "SupplId",
            SupplItemCode = "SupplItemCode",
            StkUnit = "StkUnit",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            StockFg = "StockFg",
            VatType = "VatType",
            VatCode = "VatCode",
            MinStockQty = "MinStockQty",
            MaxStockQty = "MaxStockQty",
            PurLeadTime = "PurLeadTime",
            ConsignFg = "ConsignFg",
            ConsignGp = "ConsignGp",
            NonAllowtoDiscountFg = "NonAllowtoDiscountFg",
            CusProductTypeNbp = "CusProductTypeNbp",
            CusProductSalesBeforeFlag = "CusProductSalesBeforeFlag",
            CusProductSalesBeforeReferFlag = "CusProductSalesBeforeReferFlag",
            CusProductSalesBeforeRefer = "CusProductSalesBeforeRefer",
            SellUnitPrice1 = "SellUnitPrice1",
            SellUnitPrice2 = "SellUnitPrice2",
            SellUnitPrice3 = "SellUnitPrice3",
            SellUnitPrice4 = "SellUnitPrice4",
            SellUnitPrice5 = "SellUnitPrice5",
            SellUnitPrice6 = "SellUnitPrice6",
            PurUnitPrice = "PurUnitPrice",
            DeliverCost = "DeliverCost",
            SetItemFg = "SetItemFg",
            ProductCpDesc1 = "ProductCpDesc1",
            ProductCpDesc2 = "ProductCpDesc2",
            ProductCpComponent = "ProductCpComponent",
            ProductCpHowToUse = "ProductCpHowToUse",
            ProductCpWarning = "ProductCpWarning",
            CreateDate = "CreateDate",
            CreateBy = "CreateBy"
        }
    }
}
